import {createContext, useContext, useMemo} from 'react';

export interface SalesConfig {
  salesOnly: boolean;
}

const DefaultSalesConfig: SalesConfig = {
  salesOnly: false,
};

const SalesContext = createContext<SalesConfig>(DefaultSalesConfig);

type Props = {
  value?: SalesConfig;
  children: React.ReactNode;
};

export function SalesProvider({value, children}: Props) {
  const salesConfig = useMemo(() => {
    if (value) {
      return value;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const salesOnly = urlParams.get('salesOnly') === 'true';

    return {
      salesOnly,
    };
  }, [value]);

  return (
    <SalesContext.Provider value={salesConfig}>
      {children}
    </SalesContext.Provider>
  );
}

export function useSales() {
  return useContext(SalesContext);
}
